import { faMars, faVenus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Checkbox } from "antd";
import { BaseFilterProps } from "interfaces/filter-component-base";
import { useEffect, useState } from "react";
import { AudienceEnum } from "enums/AudienceEnum";
import "./AudienceFilter.scss";

const AudienceFilter = (props: BaseFilterProps) => {
  const { onChangeValues, values } = props;
  const [selectedValues, setSelectedValues] = useState<string[]>([]);

  useEffect(() => {
    if (values && Array.isArray(values)) {
      setSelectedValues(values);
    } else if (values && typeof values === "string") {
      setSelectedValues(values.split(";"));
    } else {
      setSelectedValues([]);
    }
  }, [values]);

  const handleCheckboxChange = (ev: any) => {
    const checkboxValue = ev.target.value;
    const isChecked = ev.target.checked;

    let newValues: string[];
    if (isChecked) {
      newValues = [...selectedValues, checkboxValue];
    } else {
      newValues = selectedValues.filter((v) => v !== checkboxValue);
    }

    const uniqueValues = Array.from(new Set(newValues));
    setSelectedValues(uniqueValues);

    if (onChangeValues) {
      onChangeValues(uniqueValues.join(";"));
    }
  };

  const handleItemClick = (itemValues: string[]) => {
    const allSelected = itemValues.every((value) =>
      selectedValues.includes(value)
    );

    let newValues: string[];
    if (allSelected) {
      newValues = selectedValues.filter((v) => !itemValues.includes(v));
    } else {
      newValues = [...selectedValues];
      itemValues.forEach((value) => {
        if (!newValues.includes(value)) {
          newValues.push(value);
        }
      });
    }

    const uniqueValues = Array.from(new Set(newValues));
    setSelectedValues(uniqueValues);

    if (onChangeValues) {
      onChangeValues(uniqueValues.join(";"));
    }
  };

  const handleCheckboxContainerClick = (
    e: React.MouseEvent,
    itemValues: string[]
  ) => {
    e.stopPropagation();
  };

  return (
    <div className="audience-filter">
      <div
        className="audience-filter-item"
        onClick={() => handleItemClick([AudienceEnum.Babies])}
      >
        <div className="audience-filter-item-text">
          <p className="target-age">4-</p>
          <p className="target-subtitle">Babies</p>
        </div>
        <div
          className="audience-filter-item-checkboxes"
          onClick={(e) =>
            handleCheckboxContainerClick(e, [AudienceEnum.Babies])
          }
        >
          <label>
            <div className="checkboxes-icons">
              <FontAwesomeIcon icon={faMars} color="#2563eb" />
              <FontAwesomeIcon icon={faVenus} color="#db2777" />
            </div>
            <Checkbox
              value={AudienceEnum.Babies}
              checked={selectedValues.includes(AudienceEnum.Babies)}
              onChange={handleCheckboxChange}
            />
          </label>
        </div>
      </div>
      <div
        className="audience-filter-item"
        onClick={() => handleItemClick([AudienceEnum.Children])}
      >
        <div className="audience-filter-item-text">
          <p className="target-age">13-17</p>
          <p className="target-subtitle">Teen</p>
        </div>
        <div
          className="audience-filter-item-checkboxes"
          onClick={(e) =>
            handleCheckboxContainerClick(e, [AudienceEnum.Children])
          }
        >
          <label>
            <div className="checkboxes-icons">
              <FontAwesomeIcon icon={faMars} color="#2563eb" />
              <FontAwesomeIcon icon={faVenus} color="#db2777" />
            </div>
            <Checkbox
              value={AudienceEnum.Children}
              checked={selectedValues.includes(AudienceEnum.Children)}
              onChange={handleCheckboxChange}
            />
          </label>
        </div>
      </div>
      <div
        className="audience-filter-item"
        onClick={() =>
          handleItemClick([AudienceEnum.YoungMen, AudienceEnum.YoungWomen])
        }
      >
        <div className="audience-filter-item-text">
          <p className="target-age">18-24</p>
          <p className="target-subtitle">Young Adult</p>
        </div>
        <div
          className="audience-filter-item-checkboxes"
          onClick={(e) =>
            handleCheckboxContainerClick(e, [
              AudienceEnum.YoungMen,
              AudienceEnum.YoungWomen,
            ])
          }
        >
          <label>
            <div className="checkboxes-icons">
              <FontAwesomeIcon icon={faVenus} color="#db2777" />
            </div>
            <Checkbox
              value={AudienceEnum.YoungMen}
              checked={selectedValues.includes(AudienceEnum.YoungMen)}
              onChange={handleCheckboxChange}
            />
          </label>
          <label>
            <div className="checkboxes-icons">
              <FontAwesomeIcon icon={faMars} color="#2563eb" />
            </div>
            <Checkbox
              value={AudienceEnum.YoungWomen}
              checked={selectedValues.includes(AudienceEnum.YoungWomen)}
              onChange={handleCheckboxChange}
            />
          </label>
        </div>
      </div>
      <div
        className="audience-filter-item"
        onClick={() => handleItemClick([AudienceEnum.Women, AudienceEnum.Men])}
      >
        <div className="audience-filter-item-text">
          <p className="target-age">25-34</p>
          <p className="target-subtitle">Adult</p>
        </div>
        <div
          className="audience-filter-item-checkboxes"
          onClick={(e) =>
            handleCheckboxContainerClick(e, [
              AudienceEnum.Women,
              AudienceEnum.Men,
            ])
          }
        >
          <label>
            <div className="checkboxes-icons">
              <FontAwesomeIcon icon={faVenus} color="#db2777" />
            </div>
            <Checkbox
              value={AudienceEnum.Women}
              checked={selectedValues.includes(AudienceEnum.Women)}
              onChange={handleCheckboxChange}
            />
          </label>
          <label>
            <div className="checkboxes-icons">
              <FontAwesomeIcon icon={faMars} color="#2563eb" />
            </div>
            <Checkbox
              value={AudienceEnum.Men}
              checked={selectedValues.includes(AudienceEnum.Men)}
              onChange={handleCheckboxChange}
            />
          </label>
        </div>
      </div>
      <div
        className="audience-filter-item"
        onClick={() =>
          handleItemClick([AudienceEnum.OldWomen, AudienceEnum.OldMen])
        }
      >
        <div className="audience-filter-item-text">
          <p className="target-age">45+</p>
          <p className="target-subtitle">Mature</p>
        </div>
        <div
          className="audience-filter-item-checkboxes"
          onClick={(e) =>
            handleCheckboxContainerClick(e, [
              AudienceEnum.OldWomen,
              AudienceEnum.OldMen,
            ])
          }
        >
          <label>
            <div className="checkboxes-icons">
              <FontAwesomeIcon icon={faVenus} color="#db2777" />
            </div>
            <Checkbox
              value={AudienceEnum.OldWomen}
              checked={selectedValues.includes(AudienceEnum.OldWomen)}
              onChange={handleCheckboxChange}
            />
          </label>
          <label>
            <div className="checkboxes-icons">
              <FontAwesomeIcon icon={faMars} color="#2563eb" />
            </div>
            <Checkbox
              value={AudienceEnum.OldMen}
              checked={selectedValues.includes(AudienceEnum.OldMen)}
              onChange={handleCheckboxChange}
            />
          </label>
        </div>
      </div>
    </div>
  );
};

export default AudienceFilter;
